import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Scooter20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M9.60836 3.85748L11.8698 3.7346C12.7269 3.68803 13.4966 4.25602 13.7048 5.08876L15.1489 10.8651C15.2132 10.8605 15.278 10.8582 15.3435 10.8582C16.8274 10.8582 18.0304 12.0611 18.0304 13.545C18.0304 15.029 16.8274 16.2319 15.3435 16.2319C13.8596 16.2319 12.6566 15.029 12.6566 13.545C12.6566 12.7813 12.9753 12.092 13.4869 11.6028L11.967 5.52322L9.70555 5.6461L9.60836 3.85748ZM16.2391 13.545C16.2391 14.0397 15.8381 14.4407 15.3435 14.4407C14.8489 14.4407 14.4479 14.0397 14.4479 13.545C14.4479 13.0504 14.8489 12.6494 15.3435 12.6494C15.8381 12.6494 16.2391 13.0504 16.2391 13.545Z" fill={color} />
<path fillRule="evenodd" clipRule="evenodd" d="M8.0256 14.4406C7.65677 15.4842 6.66149 16.2319 5.49157 16.2319C4.00765 16.2319 2.80469 15.029 2.80469 13.545C2.80469 12.0611 4.00765 10.8582 5.49157 10.8582C6.66143 10.8582 7.65667 11.6058 8.02554 12.6493H10.4298C10.5242 11.4602 11.1578 10.3719 12.1598 9.70396L12.6566 11.4342C12.2068 12.033 11.9403 12.7773 11.9403 13.5839C11.9403 13.8791 11.976 14.1661 12.0434 14.4406H8.0256ZM5.49157 14.4407C5.98622 14.4407 6.3872 14.0397 6.3872 13.545C6.3872 13.0504 5.98622 12.6494 5.49157 12.6494C4.99693 12.6494 4.59595 13.0504 4.59595 13.545C4.59595 14.0397 4.99693 14.4407 5.49157 14.4407Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
